import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";

const FakeLink = styled.div`
  margin: 5px;
  &:hover {
    cursor: pointer;
  }
`;

const FooterNav = ({ className, ...props }) => {
  const classes = classNames("footer-nav", className);

  return (
    <nav {...props} className={classes}>
      <ul className="list-reset">
        <li>
          <FakeLink>Contact </FakeLink>{" "}
        </li>
        <li>
          <FakeLink>About us</FakeLink>
        </li>
        <li>
          <FakeLink> FAQ's </FakeLink>
        </li>
        <li>
          <FakeLink> Support </FakeLink>
        </li>
      </ul>
    </nav>
  );
};

export default FooterNav;
